import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CabinetButtonComponent } from '@nebalkon-workspace/cabinet-client';
import { OrderStatuses } from '@nebalkon-workspace/order-api';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';
import type { StaffOrderActionId } from '../staff-order-current-flow.model';
import type { StaffOrderSupportedAction } from '../staff-order-supported-actions.model';

@Component({
  selector: 'lib-staff-order-detail-next-action',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, CabinetButtonComponent],
  templateUrl: './staff-order-detail-next-action.component.html',
  styleUrl: './staff-order-detail-next-action.component.scss',
})
export class StaffOrderDetailNextActionComponent {
  readonly facade = inject(StaffOrderDetailFacade);

  onPrimaryAction(): void {
    const action = this.facade.orderActions()?.cockpitPrimaryAction;
    if (!action?.available) {
      return;
    }
    this.facade.dispatchCockpitAction(action.id);
  }

  cancelAction(): StaffOrderSupportedAction | null {
    if (this.facade.row()?.status === OrderStatuses.New) {
      return null;
    }

    return (
      this.facade
        .orderActions()
        ?.cockpitActionGroups?.destructive.find(
          (action) => action.id === 'cancel',
        ) ?? null
    );
  }

  onSecondaryAction(actionId: StaffOrderActionId): void {
    this.facade.dispatchCockpitAction(actionId);
  }
}
